import { useState, useEffect } from 'react';
import Config from '../global/env';
import axios from 'axios';

function useSessionData(): any {
    const [sessionData, setSessionData] = useState(null);

    useEffect(() => {
        async function getSessionInfo() {
            const apiURL = Config.sessionInfoURL;
            const { data } = await axios.get(apiURL);
            setSessionData(data.session);
        }

        if(!sessionData) {
            getSessionInfo();
        }
    }, []);

    return sessionData;
}

export default useSessionData;